import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import ModernHeader from './ModernHeader';
import LanguageSwitcher from './LanguageSwitcher';
import CanonicalLink from './CanonicalLink';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50">
      <CanonicalLink />
      <ModernHeader />
      <main className="py-6 mt-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {children}
        </div>
      </main>
      <footer className="bg-white border-t border-gray-200 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center justify-center space-y-4">
            <div className="flex items-center justify-center">
              <LanguageSwitcher />
            </div>
            <div className="flex flex-wrap justify-center space-x-4 text-sm">
              <a href="/about" className="text-gray-500 hover:text-primary-600 transition-colors">
                {t('nav.about', 'About')}
              </a>
              <a href="/privacy-policy" className="text-gray-500 hover:text-primary-600 transition-colors">
                {t('nav.privacy', 'Privacy Policy')}
              </a>
              <a href="/terms" className="text-gray-500 hover:text-primary-600 transition-colors">
                {t('nav.terms', 'Terms of Service')}
              </a>
            </div>
            <p className="text-center text-sm text-gray-500">
              &copy; {new Date().getFullYear()} Nemlingo. {t('app.allRightsReserved', 'All rights reserved.')}
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
